import { X, Target } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function MissionPanel({ onClose }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/60 z-40" onClick={onClose}></div>

      {/* Sliding Panel */}
      <div className="fixed right-0 top-0 h-full w-full max-w-4xl bg-white shadow-2xl z-50 overflow-y-auto animate-slide-in">

        {/* Top Spacer to clear navbar */}
        <div className="h-20 bg-white"></div>

        {/* Sticky Header */}
        <div className="sticky top-20 bg-white border-b border-gray-200 p-6 z-20">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                  <Target className="text-white" size={20} />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Our Mission</h2>
              </div>
              <p className="text-sm text-gray-600">Democratising AI marketing for all businesses</p>
            </div>
            <button
              onClick={onClose}
              className="ml-4 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all"
              aria-label="Close panel"
            >
              <X size={24} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">

          {/* Mission Statement */}
          <div>
            <p className="text-base text-gray-700 leading-relaxed">
              At Digital Trent, we believe powerful marketing automation shouldn't be reserved for enterprise businesses with million-pound budgets. Our mission is to democratise AI-powered marketing by making sophisticated tools accessible, affordable, and simple to use for growing businesses.
            </p>
          </div>

          {/* Key Points */}
          <div className="space-y-4">
            <div className="border-l-4 border-blue-600 pl-4">
              <h4 className="text-base font-bold text-gray-900 mb-2">Accessible Technology</h4>
              <p className="text-sm text-gray-600">Intuitive interfaces anyone can use. No coding required, no complex dashboards—just simple, powerful tools that work.</p>
            </div>

            <div className="border-l-4 border-blue-600 pl-4">
              <h4 className="text-base font-bold text-gray-900 mb-2">Affordable Pricing</h4>
              <p className="text-sm text-gray-600">Enterprise-grade AI marketing at startup prices. Starting from just £49/month, scaling with your business.</p>
            </div>

            <div className="border-l-4 border-blue-600 pl-4">
              <h4 className="text-base font-bold text-gray-900 mb-2">End-to-End Automation</h4>
              <p className="text-sm text-gray-600">From strategy to content generation, scheduling, and analytics—we handle it all so you can focus on running your business.</p>
            </div>
          </div>

          {/* Impact */}
          <div className="bg-gray-50 border border-gray-200 p-5 rounded-lg">
            <h3 className="text-base font-bold text-gray-900 mb-3">Our Impact</h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li>• Small businesses compete with large corporations using the same AI strategies</li>
              <li>• Save 15+ hours per week and reduce costs by up to 70%</li>
              <li>• Average 40% increase in engagement and 25% revenue boost in 3 months</li>
            </ul>
          </div>

        </div>

        {/* CTA at Bottom */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6">
          <button
            onClick={() => navigate('/signup')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all"
          >
            Start Free Trial
          </button>
        </div>
      </div>

      {/* Animation Styles */}
      <style jsx>{`
        @keyframes slide-in {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slide-in {
          animation: slide-in 0.3s ease-out;
        }
      `}</style>
    </>
  );
}
